import React from 'react';
import { string } from 'prop-types';

export default function TextMediaItemsIntro({ listingIntro }) {
    return (
        <div className="listing-intro container" dangerouslySetInnerHTML={{ __html: listingIntro }} />
    );
}

TextMediaItemsIntro.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    listingIntro: string.isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/items/TextMediaItemsIntro.jsx